import { Directive } from '@angular/core';
import { ImmomioIconName, ITicketAttachment, MasterdataChangeType } from '../../models';
import { RouterService } from '../../services';
import { Store } from '@ngrx/store';
import * as fromMasterDataState from '../../+state';
import { IMasterDataState } from '../../+state';
import { map, Observable, take } from 'rxjs';

@Directive()
export abstract class UserEditFormsPageBaseComponent {
  public immomioIconName = ImmomioIconName;
  public closeButton: ImmomioIconName = ImmomioIconName.Close;
  public masterDataChangeTypeSelectedConfiguration$: Observable<string | null>;
  public masterDataChangeType = MasterdataChangeType;

  constructor(
    protected masterDataStore: Store<IMasterDataState>,
    protected routerService: RouterService
  ) {
    this.masterDataChangeTypeSelectedConfiguration$ = this.masterDataStore
      .select(fromMasterDataState.getMasterDataChange)
      .pipe(
        take(1),
        map(masterDataChange => masterDataChange?.selectedChangeConfiguration?.changeType)
      );
  }

  public goToOverviewPage(formData, type: MasterdataChangeType) {
    if (type === MasterdataChangeType.NAME && formData.name?.attachments?.length > 0) {
      formData.name.attachments = this.formatAttachments(formData.name.attachments);
    }

    let contractIds: number[] = [];
    if (type === MasterdataChangeType.PAYMENT && formData.payment?.selectedContracts?.length > 0) {
      contractIds = formData.payment?.selectedContracts.map(contract => contract.id);
    }

    this.masterDataStore.dispatch(
      fromMasterDataState.SetMasterDataChange({
        masterDataChange: {
          masterDataChangeRequest: { type, ...formData, contractIds },
        },
      })
    );

    this.handleNavigation(type);
  }

  public resetMasterDataChange() {
    this.masterDataStore.dispatch(fromMasterDataState.ResetMasterDataChange());
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected handleNavigation(type?: MasterdataChangeType) {
    void null;
  }
  private formatAttachments(attachments: ITicketAttachment[]) {
    return attachments.map(attachment => {
      const { name, extension, content } = attachment;
      return { name, extension, content };
    });
  }
}
